export const tablet = "@media (min-width: 576px) and (max-width: 767px)";

export const tabletAndSmaller = "@media (max-width: 767px)";

export const mediumPhone = "@media (max-width: 575px)";

export const largeDesktop = "@media (min-width: 1200px)";

export const desktop = "@media (min-width: 992px)";

export const smallDesktop = "@media (min-width: 768px) and (max-width: 991px)";
